import wNumb from 'wnumb';

const moneyFormatter = wNumb({
    mark: ',',
    thousand: ' ',
    decimals: 2,
    prefix: '',
    suffix: ' €'
});

const moneyFormat = function (value, divisor = 100) {
    return moneyFormatter.to(value / divisor);
};

export {
    moneyFormat,
    moneyFormatter
};



// WEBPACK FOOTER //
// ./src/SiteBundle/Resources/assets/filters/money.js